import { useTranslation } from 'react-i18next';

import type { OrderLabel } from '@nucleus-commerce/api-client/admin';
import { Badge } from '@nucleus-commerce/ui/components/badge';
import { cn } from '@nucleus-commerce/ui/lib/utils';

const TONE: Record<OrderLabel, string> = {
  delayed: 'bg-destructive/10 text-destructive border-transparent',
  confirmation_not_received:
    'bg-warning/20 text-warning-foreground border-transparent dark:bg-warning/25',
  review_not_answered:
    'bg-warning/20 text-warning-foreground border-transparent dark:bg-warning/25',
  changes_requested: 'bg-primary/10 text-foreground border-transparent',
};

export interface OrderLabelChipsProps {
  labels: readonly OrderLabel[];
  className?: string;
}

/** The order's computed production labels; renders nothing when there are none. */
export function OrderLabelChips({ labels, className }: OrderLabelChipsProps) {
  const { t } = useTranslation('production');
  if (labels.length === 0) return null;
  return (
    <ul className={cn('flex flex-wrap gap-1', className)} aria-label={t('labelsAria')}>
      {labels.map((label) => (
        <li key={label}>
          <Badge variant="outline" className={TONE[label]}>
            {t(`label.${label}`)}
          </Badge>
        </li>
      ))}
    </ul>
  );
}
